import { wsService } from "../wsService";

const section = "roles";

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function listModules(param = {}) {
  return wsService.make_get_request(section + "/modules/list", param)
}

export const rolesService = {
  section,
  listModules,
  filter,
  remove,
  create,
  update,
};
